import React from 'react';

function Servicespage() {
    return (
        <div>
            <h1>
                Blance Services
            </h1>
        </div>
    )
}

export default Servicespage;